import React from 'react';
import {
  Box,
  ButtonProps,
  createStyles,
  Theme,
  withStyles,
} from '@material-ui/core';
import FsButton from 'ui-elements/buttons/FsButton';

export const ContainerBox = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: spacing(3),
    [breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
}))((props) => <Box {...props} />);

export const ReportActionButton = withStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(3),
    },
  })
)((props: ButtonProps) => <FsButton {...props} />);
